<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CustomerForm from "./forms/customer-form.vue";
import CustomTable from "../../../components/tables/custom-table.vue";
import AddButton from "../../../components/buttons/add-button.vue";

/**
 * Customers Component
 */
export default {
  components: {
    Layout,
    PageHeader,
    AddButton,
    CustomerForm,
    CustomTable
  },
  data() {
    return {
      modalId:'customer-form-modal',
      pageHeader:{
        title: "Customers",
        breadcrumbs: [
          {
            text: "Customers",
            href: "/customers",
            active: true
          }
        ],
      },
      table:{
        url:'/customers',
        fields:[
          { key: "identification_type.prefix", label: "Identification Type", sortable: false },
          { key: "identification", label: "Identification", sortable: false },
          { key: "fullname", label: "Name", sortable: false },
        ]
      },
      selectedItemId:null      
    };
  },
  methods: {
    showEditModal(item) {
      this.selectedItemId = item?.id || null;
      this.$bvModal.show(this.modalId);
    },
    onSuccess(){
      this.$refs.customerTable.refresh();
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="pageHeader?.title" :items="pageHeader?.breadcrumbs" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <CustomerForm :modal-id="modalId" :id="selectedItemId" @onSuccess="onSuccess"></CustomerForm>
            <div class="text-right">
              <AddButton @click="showEditModal"></AddButton>
            </div>
            <CustomTable :url="table.url" :fields="table.fields" @edit="showEditModal" ref="customerTable"></CustomTable>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>